// components
import { ProductView } from "./product-view";

// pipes
import { titleCasePipe } from "shared/pipes";

const RecommendationItem = ({ category = null, data = null }) => {

    if (!category || !data) {
        return null;
    }

    if (data.length === 0) {
        return null;
    }

    const availableProducts = data.filter((d) => d.available === true);

    if (!availableProducts.length) {
        return (
            <article className="message">
                <div className="message-body">
                    No available products to recommend for <strong>{category}</strong>.
                </div>
            </article>
        );
    }

    return (
        <>
            <p className="title is-size-1">
                {titleCasePipe.transform(category)}
            </p>

            <div className="columns is-multiline">
                {availableProducts.map((product, index) => {
                    return (
                        <div key={`${product.barcode}-${index}`} className="column is-4">
                            <ProductView category={category} data={product} />
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export { RecommendationItem };
